<template>
<!-- 自定义一个routerlink组件样式 -->
  <router-link :to="to" :tag="tag" class="router_link">{{linkTitle}}</router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: 'div'
    },
    linkTitle: {
      type: String,
      default: ''
    }
    // color: {
    //   type: String,
    //   default: '#409EFF'
    // }
  }
}
</script>

<style lang="scss" scoped>
.router_link {
  display: inline-block;
  height: 100%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/link.vue